import { useQuery } from '@tanstack/react-query';
import { fetchBanners } from '../services/bannersAPI';

const BANNERS_QUERY_KEY = ['banners'];

const useBannersQuery = () =>
  useQuery({
    queryKey: BANNERS_QUERY_KEY,
    queryFn: fetchBanners,
    staleTime: 1000 * 60 * 10, // 10 minutes
    cacheTime: 1000 * 60 * 60, // 1 hour
  });

/**
 * Returns the slides + config for a single banner by its bannerKey.
 * Falls back to an empty slides array while loading or on error.
 *
 * @param {'home_hero' | 'electronics_hero' | 'dashboard_hero'} bannerKey
 */
export const useBanner = (bannerKey) => {
  const { data, isLoading, isError } = useBannersQuery();

  const banners = data?.banners ?? [];
  const banner = banners.find((b) => b.bannerKey === bannerKey) ?? null;

  const slides = banner?.slides
    ? banner.slides.filter((s) => s.isActive).sort((a, b) => a.order - b.order)
    : [];

  return {
    slides,
    autoSlideInterval: banner?.autoSlideInterval ?? 3000,
    aspectRatio: banner?.aspectRatio ?? null,
    height: banner?.height ?? null,
    isLoading,
    isError,
  };
};
